define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'router', 'scroll'],
    function ($, transit, modernizr, container, preloader, router, scroll) {

        var module = (function () {

            var name = 'module-fan-touchpoint-tv';

            var model = container.getBaseModel(name);
            var view = container.getBaseView(name);
            var pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {

            }

            /* view */

            view.publicVars = {};

            view.privateVars = {

            };

            view.startup = function () {
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleFanTouchpointTvHeaderMenuId, 'animate__faster animate__fadeIn', 'fan-touchpoint-tv', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleFanTouchpointTvSectionBtnCls, 'animate__faster animate__slideInLeft', 'fan-touchpoint-tv', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleFanTouchpointTvSlideSectionContentInnerAnimId, 'animate__faster animate__slideInRight', 'fan-touchpoint-tv', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleFanTouchpointTvBoxesId, 'animate__faster animate__zoomIn', 'fan-touchpoint-tv', {});

                const windowWidth = $(window).width();

                if(windowWidth > 1920) {
                    preloader.setPreloadBulk('module-fan-touchpoint-tv-2560', view.publicVars.preloadTab2560);
                }

                if(windowWidth <= 1920 && windowWidth > 1024) {
                    preloader.setPreloadBulk('module-fan-touchpoint-tv-1920', view.publicVars.preloadTab1920);
                }

                if(windowWidth <= 1024 && windowWidth > 767) {
                    preloader.setPreloadBulk('module-fan-touchpoint-tv-1024', view.publicVars.preloadTab1024);
                }

                if(windowWidth <= 767 && windowWidth > 599) {
                    preloader.setPreloadBulk('module-fan-touchpoint-tv-768', view.publicVars.preloadTab768);
                }
            };

            view.bind = function () {
                $(view.publicVars.cssId.moduleFanTouchpointTvBoxesBoxCls).click(function () {
                    view.methods.handleBoxClick(this);
                });
            };

            view.methods = {
                handleBoxClick: function (handler) {
                    // $(view.publicVars.cssId.moduleFanTouchpointTvSlideSectionContentInnerCls).transit({ opacity: 0}, 300);
                    $(view.publicVars.cssId.moduleFanTouchpointTvSlideSectionContentInnerCls).addClass(view.publicVars.cssId.isHiddenCls.substr(1));
                    const bkgCls = container.getData($(handler)[0], 'bkg.cls');
                    $('.' + view.publicVars.cssId.moduleFanTouchpointTvBkgId.substr(1)).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                    $(view.publicVars.cssId.moduleFanTouchpointTvBkgId + '-' + bkgCls).addClass(view.publicVars.cssId.isActiveCls.substr(1));

                    $(view.publicVars.cssId.moduleFanTouchpointTvBoxesCls).addClass(view.publicVars.cssId.isSelectedCls.substr(1));
                    $(view.publicVars.cssId.moduleFanTouchpointTvBoxesBoxCls).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                    $(handler).addClass(view.publicVars.cssId.isActiveCls.substr(1));
                }
            };

            /* custom events */
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                    scroll.init();
                }
            };


        })();

        return module;


    });
